import { FunctionComponent } from 'react';
import { LoggedInUser, SharedFooter } from '@atlassian/learning-components';

interface Props {
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser | undefined;
}

export const Footer: FunctionComponent<Props> = ({
  isLoggedIn,
  loggedInUser,
}) => (
  <>
    <SharedFooter
      isLoggedIn={isLoggedIn}
      email={loggedInUser?.email || 'test@atlassian.com'}
    />
  </>
);
